import { API_PREFIX_LEGACY } from '@/const/api';
import { useEffect, useState } from 'react';
import { fetchWithRetry } from '../utils/fetchWithRetry';

const URL = `/${API_PREFIX_LEGACY}/settings`;

export interface UserSettings {
  userFirstName?: string;
  userLastName?: string;
  email?: string;
  settingsPath?: string;
  myAccountPath?: string;
  logOutPath?: string;
  quotePath?: string;
  quoteId?: string;
  cartPath?: string;
  showCart?: boolean;
  cartCount?: number;
  userId?: string;
}

const initialUserState = {
  userFirstName: undefined,
  userLastName: undefined,
  email: undefined,
  settingsPath: undefined,
  myAccountPath: undefined,
  logOutPath: undefined,
  quotePath: undefined,
  quoteId: undefined,
  cartPath: undefined,
  showCart: undefined,
  cartCount: undefined,
  userId: undefined,
};

interface UseGetAuthUserProps {
  user: UserSettings | null;
  status: 'idle' | 'loading' | 'success' | 'error';
}

export const useGetAuthUser = (): UseGetAuthUserProps => {
  const [state, setState] = useState<UseGetAuthUserProps>({
    user: initialUserState,
    status: 'idle',
  });

  useEffect(() => {
    fetchWithRetry<UserSettings>(URL)
      .then(user => {
        setState({ user, status: 'success' });
      })
      .catch(() => {
        setState({ user: null, status: 'error' });
      });
  }, []);

  return state;
};
